module.exports = __webpack_public_path__ + "img/htwk.b20a5027.svg";